import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 col-sm-6" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "col-lg-2 col-sm-6" }
const _hoisted_8 = { class: "form-group mb-4" }
const _hoisted_9 = { value: null }
const _hoisted_10 = { value: "true" }
const _hoisted_11 = { value: "false" }
const _hoisted_12 = { class: "col-lg-6 col-sm-6 text-end mt-4" }
const _hoisted_13 = { class: "d-inline-flex flex-wrap gap-3 justify-content-end" }
const _hoisted_14 = { class: "default-table-area style-two default-table-width" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table align-middle" }
const _hoisted_17 = { class: "text-body text-center" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-body" }
const _hoisted_20 = { class: "text-body" }
const _hoisted_21 = { class: "text-body" }
const _hoisted_22 = { class: "text-body" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "p-4 pt-lg-4" }
const _hoisted_26 = {
  id: "mdlBulkloadCompanies",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "mdlBulkloadCompaniesLabel",
  "aria-hidden": "true",
  size: "large"
}
const _hoisted_27 = { class: "modal-dialog modal-lg" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-body" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-6 col-sm-6" }
const _hoisted_32 = { class: "form-group mb-4" }
const _hoisted_33 = {
  key: 0,
  class: "input-error"
}
const _hoisted_34 = { class: "col-lg-6 col-sm-6" }
const _hoisted_35 = { class: "form-group mb-4" }
const _hoisted_36 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayLoader = _resolveComponent("OverlayLoader")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_FilePond = _resolveComponent("FilePond")!
  const _component_b_link = _resolveComponent("b-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_OverlayLoader, { visible: _ctx.isLoading }, null, 8 /* PROPS */, ["visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre/RUC", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event)),
                    class: "form-control h-45",
                    placeholder: "Ingrese nombre/ruc"
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      _ctx.filters.name,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label text-secondary" }, "Estado Registro", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.isActive) = $event)),
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example"
                  }, [
                    _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.LABELS.SELECT_ALL), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.STATUS.ACTIVE), 1 /* TEXT */),
                    _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.STATUS.INACTIVE), 1 /* TEXT */)
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, _ctx.filters.isActive]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getCompanies(_ctx.currentPage)), ["prevent"])),
                    class: "btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  }, " Buscar "),
                  _createVNode(_component_RouterLink, { to: "/company/create" }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                      }, [
                        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                          _createElementVNode("span", null, "Agregar Empresa/Institución")
                        ])
                      ], -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bulkloadCompaniesModal())),
                    class: "btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  }, " Carga Masiva ")
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "#"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Empresas/Instituciones"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "RUC"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Estado Registro"),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Creado"),
                    _createElementVNode("br"),
                    _createTextVNode(" por ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode("creación")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode("Modificado "),
                    _createElementVNode("br"),
                    _createTextVNode("por")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, [
                    _createTextVNode(" Fecha "),
                    _createElementVNode("br"),
                    _createTextVNode(" modificación ")
                  ]),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-center"
                  }, "Opciones")
                ])
              ], -1 /* HOISTED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1 + (_ctx.currentPage - 1) * _ctx.pageSize), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.firstName) + " " + _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.firstName) + " " + _toDisplayString(item.ruc), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.confirmChangeStatus(item.id, item.isActive)),
                        class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeStatusClass(item.isActive)]),
                        role: "button"
                      }, _toDisplayString(item.isActive ? _ctx.STATUS.ACTIVE : _ctx.STATUS.INACTIVE), 11 /* TEXT, CLASS, PROPS */, _hoisted_18)
                    ]),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(item.createdBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(item.createdAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.updatedBy), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(item.updatedAtDateTimeString), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_RouterLink, {
                          to: `/company/edit/${item.id}`
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " edit ", -1 /* HOISTED */)
                          ]))]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Pagination, {
              currentPage: _ctx.currentPage,
              pageSize: _ctx.pageSize,
              totalItems: _ctx.totalItems,
              "onUpdate:page": _ctx.fetchPage
            }, null, 8 /* PROPS */, ["currentPage", "pageSize", "totalItems", "onUpdate:page"])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "mdlBulkloadCompaniesLabel"
            }, " Carga Masiva de Empresa/Institución "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label text-secondary strong" }, "Archivo", -1 /* HOISTED */)),
                  _createVNode(_component_FilePond, {
                    name: "companyDataFile",
                    maxFileSize: '20MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `El tipo de archivo permitido es: .xlsx`,
                    credits: "",
                    onUpdatefiles: _ctx.handleUpdateFiles,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('companyDataFile')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "onUpdatefiles"]),
                  (_ctx.errors.companyDataFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.errors.companyDataFile), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_b_link, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadFile())),
                      class: "col-md-8"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createElementVNode("u", {
                          class: "text-primary",
                          style: {"cursor":"pointer"}
                        }, "Descargar Plantilla", -1 /* HOISTED */)
                      ])),
                      _: 1 /* STABLE */
                    })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary text-white",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)))
            }, " Guardar "),
            _cache[15] || (_cache[15] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger text-white",
              "data-bs-dismiss": "modal"
            }, " Cerrar ", -1 /* HOISTED */))
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}